import {
  CommentInfoFragment,
  CommentInfoFragmentType,
  SimpleFileFragment,
  SimpleFileFragmentType,
} from '@common/graphql';
import { gql } from '@common/hooks';

export type ApprovalChainApproverType = {
  id: string;
  worksMembership: {
    id: string;
    name: string;
  };
};

type ApprovalChainActionType =
  | 'staffing_request_open'
  | 'staffing_request_update'
  | 'extension_offer_active';

export type ApprovalChainStepType = {
  id: string;
  updatedAt: string;
  satisfied: boolean;
  rejected: boolean;
  approvalChainApprovers: ApprovalChainApproverType[];
  approvalChainApprovals: ApprovalChainApproverType[];
  approvalChainRejections: (ApprovalChainApproverType & {
    rejectionReason: string;
    note?: string | null;
  })[];
  comments?: CommentInfoFragmentType[] | null;
};

export type ApprovalChainType = {
  id: string;
  actionType: ApprovalChainActionType;
  satisfied: boolean;
  rejected: boolean;
  approvalDocument?: SimpleFileFragmentType | null;
  comments?: CommentInfoFragmentType[] | null;
  currentStep?: {
    id: string;
  } | null;
  currentApprovers?: ApprovalChainApproverType[] | null;
  approvalChainSteps: ApprovalChainStepType[];
};

const ApprovalChainContents = gql`
  fragment ApprovalChainContents on ApprovalChain {
    id
    actionType
    satisfied
    rejected
    approvalDocument {
      ...SimpleFileFragment
    }
    comments {
      ...CommentInfoFragment
    }
    currentStep {
      id
    }
    currentApprovers {
      id
      worksMembership {
        id
        name
      }
    }
    approvalChainSteps {
      id
      updatedAt
      satisfied
      rejected
      comments {
        ...CommentInfoFragment
      }
      approvalChainApprovers {
        id
        worksMembership {
          id
          name
        }
      }
      approvalChainApprovals {
        id
        worksMembership {
          id
          name
        }
      }
      approvalChainRejections {
        id
        rejectionReason
        note
        worksMembership {
          id
          name
        }
      }
    }
  }
  ${CommentInfoFragment}
  ${SimpleFileFragment}
`;

export const ApprovalChainContentFragments = {
  extensionOffer: gql`
    ${ApprovalChainContents}

    fragment ExtensionOfferApprovalChainsFragment on ExtensionOffer {
      approvalChains {
        ...ApprovalChainContents
      }
    }
  `,
  staffingRequest: gql`
    ${ApprovalChainContents}

    fragment StaffingRequestApprovalChainsFragment on StaffingRequest {
      approvalChains {
        ...ApprovalChainContents
      }
    }
  `,
};

export const ApprovalChainStatusFragment = {
  staffingRequest: gql`
    fragment ApprovalChainStatusStaffingRequestFragment on StaffingRequest {
      id
      approvalChains {
        id
        actionType
        satisfied
        rejected
        createdAt
        comments {
          ...CommentInfoFragment
        }
        currentApprovers {
          id
          worksMembership {
            id
            name
          }
        }
        approvalChainSteps {
          id
          satisfied
          approvalChainApprovers {
            id
            worksMembership {
              id
              name
            }
          }
          approvalChainApprovals {
            id
            worksMembership {
              id
              name
            }
          }
          approvalChainRejections {
            id
            worksMembership {
              id
              name
            }
          }
        }
      }
    }
    ${CommentInfoFragment}
  `,
};
